// The languages a reader can choose, each named in its own script with a line about what it
// changes, written in that language (so the picker needs no second language).
import type { Lang } from './types';

export const LANGUAGES: { lang: Lang; name: string; about: string }[] = [
  { lang: 'ta', name: 'தமிழ்', about: 'ஆப்பும் செய்முறைகளும் தமிழில்' },
  { lang: 'en', name: 'English', about: 'The app and recipes in English' },
  { lang: 'tg', name: 'Tanglish', about: 'App in English · names like thakkali, vengayam' },
  { lang: 'hi', name: 'हिन्दी', about: 'ऐप हिन्दी में · रेसिपी अंग्रेज़ी में' },
  { lang: 'te', name: 'తెలుగు', about: 'యాప్ తెలుగులో · వంటకాలు ఇంగ్లీష్‌లో' },
  { lang: 'kn', name: 'ಕನ್ನಡ', about: 'ಆ್ಯಪ್ ಕನ್ನಡದಲ್ಲಿ · ರೆಸಿಪಿಗಳು ಇಂಗ್ಲಿಷ್‌ನಲ್ಲಿ' },
  { lang: 'ml', name: 'മലയാളം', about: 'ആപ്പ് മലയാളത്തിൽ · പാചകക്കുറിപ്പുകൾ ഇംഗ്ലീഷിൽ' },
];

/** The html lang attribute for a language's own name (Tanglish is Latin script). */
export function langAttr(l: Lang): string {
  return l === 'tg' ? 'en' : l;
}
